import React, { useEffect, useState } from 'react';
import { DatePicker, Dialog, InputNumber, MessagePlugin, Select } from 'tdesign-react';
import dayjs from 'dayjs';
import Form from '@/components/Form';
import { resetOffsets } from '@/services/kopConsumerGroupService';
import FormInfoBlock from '@/components/FormInfoBlock';
import { isVoid } from '@/utils/common';
import useDisableButton from '@/components/DisableWrapper/useDisableButton';

const { FormItem } = Form;

export default function ResetOffsetModal({ visible, doClose, detail }) {
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();
  const resetType = Form.useWatch('resetType', form);
  const confirmBtn = useDisableButton({ loading: submitting, content: '确定' });

  const descriptions = [
    {
      label: '集群名称：',
      value: detail.clusterName,
    },
    {
      label: 'Topic：',
      value: detail.consumedTopicName,
    },
    detail.partition > -1
      ? {
          label: 'Partition：',
          value: detail.partition,
        }
      : null,
    {
      label: 'ConsumerGroup：',
      value: detail.consumerGroupName,
    },
  ].filter((item) => !isVoid(item));

  const handleSubmit = async (values) => {
    try {
      setSubmitting(true);
      if (detail.status === 'Active') {
        MessagePlugin.warning('Topic当前处于Active状态，不允许重置');
        return;
      }
      await resetOffsets({
        clusterName: detail.clusterName,
        groupName: detail.consumerGroupName,
        topicName: detail.consumedTopicName,
        timestamp: isVoid(values.timestamp) ? null : dayjs(values.timestamp).unix(),
        offset: isVoid(values.offset) ? null : values.offset,
        partition: detail.partition,
      });

      MessagePlugin.success('重置成功');
      doClose(true);
    } catch (error) {
      console.log(error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (!visible) {
      form.resetFields();
    }
  }, [form, visible]);

  return (
    <Dialog
      header='重置Offset'
      onClose={() => doClose()}
      onConfirm={() => form.submit()}
      confirmBtn={confirmBtn}
      visible={visible}
      width={550}
      placement='center'
      destroyOnClose
    >
      <Form form={form} onFinish={handleSubmit} initialValues={{ resetType: 'typeTimestamp' }}>
        <FormItem
          name='resetType'
          label='重置类型'
          rules={[{ required: true, message: '请选择重置类型' }]}
        >
          <Select
            style={{ width: '70%' }}
            options={[
              {
                label: '指定时间戳',
                value: 'typeTimestamp',
              },
              {
                label: '指定偏移量',
                value: 'typeOffset',
              },
            ]}
          />
        </FormItem>
        {resetType === 'typeOffset' && (
          <FormItem
            name='offset'
            label='偏移量'
            rules={[
              { required: true, message: '请输入偏移量' },
              { type: 'number', min: 0, message: '请输入大于等于0的数字' },
            ]}
          >
            <InputNumber min={0} decimalPlaces={0} theme='normal' style={{ width: '70%' }} />
          </FormItem>
        )}
        {resetType === 'typeTimestamp' && (
          <FormItem
            name='timestamp'
            label='自定义时间'
            rules={[{ required: true, message: '请选择时间' }]}
          >
            <DatePicker
              style={{ width: '70%' }}
              enableTimePicker
              placeholder='请选择'
              clearable
              presets={{ 此刻: dayjs().format('YYYY-MM-DD HH:mm:ss') }}
            />
          </FormItem>
        )}
        <FormInfoBlock items={descriptions} />
      </Form>
    </Dialog>
  );
}
